"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DuplicateProcessor", {
    enumerable: true,
    get: function() {
        return DuplicateProcessor;
    }
});
const _stream = require("stream");
const _papaparse = /*#__PURE__*/ _interop_require_default(require("papaparse"));
const _debug = /*#__PURE__*/ _interop_require_default(require("debug"));
const _nocodbsdk = require("nocodb-sdk");
const _common = require("@nestjs/common");
const _columnwebhookmanager = require("~/utils/column-webhook-manager");
const _models = require("~/models");
const _basesservice = require("~/services/bases.service");
const _exportImportHelpers = require("~/helpers/exportImportHelpers");
const _bulkdataaliasservice = require("~/services/bulk-data-alias.service");
const _columnsservice = require("~/services/columns.service");
const _Jobs = require("~/interface/Jobs");
const _helpers = require("~/modules/jobs/helpers");
const _exportservice = require("~/modules/jobs/jobs/export-import/export.service");
const _importservice = require("~/modules/jobs/jobs/export-import/import.service");
const _apphooksservice = require("~/services/app-hooks/app-hooks.service");
const _tablesservice = require("~/services/tables.service");
const _telemetryservice = require("~/services/telemetry.service");
const _duplicatemodelutils = require("~/utils/duplicate-model.utils");
const _tableHelpers = require("~/helpers/tableHelpers");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let DuplicateProcessor = class DuplicateProcessor {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async handleDuplicateDifferentWs(params) {
        throw new _common.NotImplementedException();
    }
    async duplicateBaseJob({ sourceBase, targetBase, dataSource, req, context, options, operation, targetContext: _targetContext }) {
        const hrTime = (0, _helpers.initTime)();
        const targetContext = _targetContext != null ? _targetContext : {
            workspace_id: targetBase.fk_workspace_id,
            base_id: targetBase.id
        };
        try {
            if ([
                _Jobs.JobTypes.DuplicateBase,
                _Jobs.JobTypes.RestoreSnapshot
            ].includes(operation) && targetContext.workspace_id !== sourceBase.fk_workspace_id) {
                await this.handleDuplicateDifferentWs({
                    sourceBase,
                    targetBase,
                    dataSource,
                    req,
                    context,
                    targetContext,
                    options
                });
            }
            if (!sourceBase || !targetBase || !dataSource) {
                throw new Error(`Base or source not found!`);
            }
            const user = req.user;
            const filteredModels = (await dataSource.getModels(context)).filter((m)=>m.source_id === dataSource.id && !m.mm && m.type === 'table');
            const models = [];
            for (const model of filteredModels){
                if (await (0, _tableHelpers.hasTableVisibilityAccess)(context, model.id, user)) {
                    models.push(model);
                }
            }
            const { serializedModels: exportedModels, idMap: exportModelMap } = await this.exportService.serializeModels(context, _extends({
                modelIds: models.map((m)=>m.id)
            }, options));
            (0, _helpers.elapsedTime)(hrTime, `serialize models schema for ${dataSource.base_id}::${dataSource.id}`, operation);
            let exportedScripts = null;
            if (!(options == null ? void 0 : options.excludeScripts)) {
                exportedScripts = await this.exportService.serializeScripts(context);
                (0, _helpers.elapsedTime)(hrTime, `serialize scripts schema for ${dataSource.base_id}`, operation);
            }
            let exportedWorkflows = null;
            if (!options.excludeWorkflows) {
                exportedWorkflows = await this.exportService.serializeWorkflows(context, {
                    idMap: exportModelMap
                }, req);
                (0, _helpers.elapsedTime)(hrTime, `serialize workflows schema for ${dataSource.base_id}`, operation);
            }
            let exportedDashboards = null;
            if (!options.excludeDashboards) {
                exportedDashboards = await this.exportService.serializeDashboards(context, {
                    idMap: exportModelMap
                }, req);
                (0, _helpers.elapsedTime)(hrTime, `serialize dashboards schema for ${dataSource.base_id}`, operation);
            }
            if (!exportedModels) {
                throw new Error(`Export failed for source '${dataSource.id}'`);
            }
            await targetBase.getSources();
            const targetBaseSource = targetBase.sources[0];
            let idMap = await this.importService.importModels(targetContext, {
                user,
                baseId: targetBase.id,
                sourceId: targetBaseSource.id,
                data: exportedModels,
                req: req,
                isDuplicateOperation: true
            });
            if (exportedScripts) {
                await this.importService.importScripts(targetContext, {
                    user,
                    baseId: targetBase.id,
                    data: exportedScripts,
                    req: req
                });
            }
            if (exportedDashboards == null ? void 0 : exportedDashboards.length) {
                idMap = await this.importService.importDashboards(targetContext, {
                    user,
                    baseId: targetBase.id,
                    data: exportedDashboards,
                    req,
                    idMap
                });
            }
            if (exportedWorkflows == null ? void 0 : exportedWorkflows.length) {
                idMap = await this.importService.importWorkflows(targetContext, {
                    user,
                    baseId: targetBase.id,
                    data: exportedWorkflows,
                    req,
                    idMap
                });
            }
            (0, _helpers.elapsedTime)(hrTime, `import models schema`, operation);
            if (!idMap) {
                throw new Error(`Import failed for source '${dataSource.id}'`);
            }
            if (!(options == null ? void 0 : options.excludeData)) {
                await this.importModelsData(targetContext, context, {
                    idMap,
                    sourceProject: sourceBase,
                    sourceModels: models,
                    destProject: targetBase,
                    destBase: targetBaseSource,
                    options,
                    hrTime,
                    req
                });
            }
            await this.projectsService.baseUpdate(targetContext, {
                baseId: targetBase.id,
                base: {
                    status: null
                },
                user: req.user,
                req
            });
            this.appHooksService.emit(_nocodbsdk.AppEvents.BASE_DUPLICATE_COMPLETE, {
                sourceBase,
                destBase: targetBase,
                user: req.user,
                req,
                context: targetContext
            });
        } catch (err) {
            var _req_user, _req_user1;
            if (targetBase == null ? void 0 : targetBase.id) {
                await this.projectsService.baseSoftDelete(targetContext, {
                    baseId: targetBase.id,
                    user: req.user,
                    req
                });
            }
            this.appHooksService.emit(_nocodbsdk.AppEvents.BASE_DUPLICATE_FAIL, {
                sourceBase,
                destBase: targetBase,
                user: req.user,
                req,
                context: targetContext,
                error: err.message
            });
            await this.telemetryService.sendSystemEvent({
                event_type: 'priority_error',
                error_trigger: 'duplicateBase',
                error_type: err == null ? void 0 : err.name,
                message: err == null ? void 0 : err.message,
                error_details: err == null ? void 0 : err.stack,
                affected_resources: [
                    req == null ? void 0 : (_req_user = req.user) == null ? void 0 : _req_user.email,
                    req == null ? void 0 : (_req_user1 = req.user) == null ? void 0 : _req_user1.id,
                    context.base_id,
                    context.workspace_id
                ]
            });
            throw err;
        }
    }
    async duplicateBase(job) {
        var _req_user;
        this.debugLog(`job started for ${job.id} (${_Jobs.JobTypes.DuplicateBase})`);
        const { context, sourceId, dupWorkspaceId, dupProjectId, req, options } = job.data;
        const baseId = context.base_id;
        // workspace templates placeholder user
        if (((_req_user = req.user) == null ? void 0 : _req_user.id) === '1') {
            delete req.user;
        }
        const excludeData = (options == null ? void 0 : options.excludeData) || false;
        const excludeHooks = (options == null ? void 0 : options.excludeHooks) || false;
        const excludeViews = (options == null ? void 0 : options.excludeViews) || false;
        const excludeComments = (options == null ? void 0 : options.excludeComments) || excludeData || false;
        const excludeUsers = (options == null ? void 0 : options.excludeUsers) || false;
        const excludeScripts = (options == null ? void 0 : options.excludeScripts) || false;
        const excludeDashboards = (options == null ? void 0 : options.excludeDashboards) || false;
        const excludeWorkflows = (options == null ? void 0 : options.excludeWorkflows) || false;
        const base = await _models.Base.get(context, baseId);
        const dupProject = await _models.Base.get({
            workspace_id: dupWorkspaceId,
            base_id: null
        }, dupProjectId);
        const source = await _models.Source.get(context, sourceId);
        await this.duplicateBaseJob({
            sourceBase: base,
            targetBase: dupProject,
            dataSource: source,
            req,
            context,
            options: {
                excludeData,
                excludeHooks,
                excludeViews,
                excludeComments,
                excludeUsers,
                excludeScripts,
                excludeDashboards,
                excludeWorkflows
            },
            operation: _Jobs.JobTypes.DuplicateBase
        });
        return {
            id: dupProject.id
        };
    }
    async duplicateModel(job) {
        this.debugLog(`job started for ${job.id} (${_Jobs.JobTypes.DuplicateModel})`);
        const hrTime = (0, _helpers.initTime)();
        const { context, sourceId, targetSourceId: _targetSourceId, modelId, title, req, options } = job.data;
        const { context: targetContext, isDifferent: _isTargetContextDifferent } = await _duplicatemodelutils.DuplicateModelUtils._.getTargetContext(context, options);
        const baseId = context.base_id;
        const excludeData = (options == null ? void 0 : options.excludeData) || false;
        const excludeHooks = (options == null ? void 0 : options.excludeHooks) || false;
        const excludeViews = (options == null ? void 0 : options.excludeViews) || false;
        const excludeComments = (options == null ? void 0 : options.excludeComments) || excludeData || false;
        const base = await _models.Base.get(context, baseId);
        const source = await _models.Source.get(context, sourceId);
        const user = req.user;
        const models = (await source.getModels(context)).filter((m)=>!m.mm && m.type === 'table');
        const sourceModel = models.find((m)=>m.id === modelId);
        const createdModels = [];
        // TODO: replace this with the one that's generated by table webhook manager
        // currently this one is to prevent webhook to trigger when duplicate mode
        // The modelId here should be of the target model, We are keeping it like this, as the event is not emitted here.
        const columnWebhookManager = (await new _columnwebhookmanager.ColumnWebhookManagerBuilder(targetContext).withModelId(modelId)).forCreate();
        try {
            await sourceModel.getColumns(context);
            const relatedModelIds = sourceModel.columns.filter((col)=>(0, _nocodbsdk.isLinksOrLTAR)(col)).map((col)=>col.colOptions.fk_related_model_id).filter((id)=>id).concat(// concat with mm models where it's custom
            sourceModel.columns.filter((col)=>(0, _nocodbsdk.isLinksOrLTAR)(col) && col.colOptions.type === 'mm' && (0, _nocodbsdk.parseProp)(col.meta).custom).map((col)=>col.colOptions.fk_mm_model_id).filter((id)=>id));
            const relatedModels = models.filter((m)=>relatedModelIds.includes(m.id));
            const exportedModel = (await this.exportService.serializeModels(context, {
                modelIds: [
                    modelId
                ],
                excludeViews,
                excludeHooks,
                excludeData,
                excludeComments
            })).serializedModels[0];
            (0, _helpers.elapsedTime)(hrTime, `serialize model schema for ${modelId}`, 'duplicateModel');
            if (!exportedModel) {
                throw new Error(`Export failed for source '${source.id}'`);
            }
            exportedModel.model.title = title;
            exportedModel.model.table_name = title.toLowerCase().replace(/ /g, '_');
            const idMap = await this.importService.importModels(context, {
                baseId,
                targetContext,
                sourceId,
                data: [
                    exportedModel
                ],
                user,
                req,
                externalModels: relatedModels,
                columnWebhookManager,
                isDuplicateOperation: true
            });
            (0, _helpers.elapsedTime)(hrTime, 'import model schema', 'duplicateModel');
            if (!idMap) {
                throw new Error(`Import failed for model '${modelId}'`);
            }
            createdModels.push((0, _exportImportHelpers.findWithIdentifier)(idMap, sourceModel.id));
            if (!excludeData) {
                const fields = {};
                for (const md of relatedModels){
                    const bts = md.columns.filter((c)=>{
                        var _c_meta;
                        return (0, _nocodbsdk.isLinksOrLTAR)(c) && (c.colOptions.type === _nocodbsdk.RelationTypes.BELONGS_TO || c.colOptions.type === _nocodbsdk.RelationTypes.ONE_TO_ONE && ((_c_meta = c.meta) == null ? void 0 : _c_meta.bt)) && c.colOptions.fk_related_model_id === sourceModel.id;
                    }).map((c)=>c.id);
                    if (bts.length > 0) {
                        fields[md.id] = fields[md.id] ? fields[md.id] : [
                            md.primaryKey.id
                        ];
                        fields[md.id].push(...bts);
                    }
                }
                await this.importModelsData(targetContext, context, {
                    idMap,
                    sourceProject: base,
                    sourceModels: [
                        sourceModel
                    ],
                    destProject: await _models.Base.get(targetContext, targetContext.base_id),
                    destBase: source,
                    hrTime,
                    modelFieldIds: fields,
                    externalModels: relatedModels,
                    req
                });
                (0, _helpers.elapsedTime)(hrTime, 'import model data', 'duplicateModel');
            }
            this.debugLog(`job completed for ${job.id} (${_Jobs.JobTypes.DuplicateModel})`);
            const res = {
                id: (0, _exportImportHelpers.findWithIdentifier)(idMap, sourceModel.id)
            };
            this.appHooksService.emit(_nocodbsdk.AppEvents.TABLE_DUPLICATE_COMPLETE, {
                sourceTable: sourceModel,
                destTable: await _models.Model.get(context, res.id),
                user: req.user,
                req,
                context
            });
            return res;
        } catch (e) {
            var _req_user, _req_user1;
            this.appHooksService.emit(_nocodbsdk.AppEvents.TABLE_DUPLICATE_FAIL, {
                sourceTable: sourceModel,
                user: req.user,
                req,
                context,
                error: e.message
            });
            if (createdModels.length > 0) {
                for (const modelId of createdModels){
                    await this.tablesService.tableDelete(context, {
                        tableId: modelId,
                        user: req.user,
                        forceDeleteRelations: true,
                        req
                    });
                }
            }
            await this.telemetryService.sendSystemEvent({
                event_type: 'priority_error',
                error_trigger: 'duplicateModel',
                error_type: e == null ? void 0 : e.name,
                message: e == null ? void 0 : e.message,
                error_details: e == null ? void 0 : e.stack,
                affected_resources: [
                    req == null ? void 0 : (_req_user = req.user) == null ? void 0 : _req_user.email,
                    req == null ? void 0 : (_req_user1 = req.user) == null ? void 0 : _req_user1.id,
                    context.base_id,
                    context.workspace_id
                ]
            });
            throw e;
        }
    }
    async duplicateColumn(job) {
        this.debugLog(`job started for ${job.id} (${_Jobs.JobTypes.DuplicateColumn})`);
        const hrTime = (0, _helpers.initTime)();
        const { context, sourceId, columnId, extra, req, options } = job.data;
        const baseId = context.base_id;
        const excludeData = (options == null ? void 0 : options.excludeData) || false;
        const base = await _models.Base.get(context, baseId);
        const sourceColumn = await _models.Column.get(context, {
            source_id: sourceId,
            colId: columnId
        });
        const user = req.user;
        const source = await _models.Source.get(context, sourceColumn.source_id);
        const models = (await source.getModels(context)).filter((m)=>!m.mm && m.type === 'table');
        const sourceModel = models.find((m)=>m.id === sourceColumn.fk_model_id);
        const columns = await sourceModel.getColumns(context);
        const title = (0, _exportImportHelpers.generateUniqueName)(`${sourceColumn.title} copy`, columns.map((p)=>p.title));
        const relatedModelIds = [
            sourceColumn
        ].filter((col)=>(0, _nocodbsdk.isLinksOrLTAR)(col)).map((col)=>col.colOptions.fk_related_model_id).filter((id)=>id);
        const relatedModels = models.filter((m)=>relatedModelIds.includes(m.id));
        const exportedModel = (await this.exportService.serializeModels(context, {
            modelIds: [
                sourceModel.id,
                ...relatedModelIds
            ],
            excludeData,
            excludeHooks: true,
            excludeViews: true,
            excludeRowColorConditions: true
        })).serializedModels[0];
        (0, _helpers.elapsedTime)(hrTime, `serialize model schema for ${sourceModel.id}`, 'duplicateColumn');
        if (!exportedModel) {
            throw new Error(`Export failed for model '${sourceModel.id}'`);
        }
        const replacedColumn = exportedModel.model.columns.find((c)=>c.id.includes(columnId));
        const columnWebhookManager = (await new _columnwebhookmanager.ColumnWebhookManagerBuilder(context).withModelId(sourceColumn.fk_model_id)).forCreate();
        try {
            // save old default value
            const oldCdf = replacedColumn.cdf;
            const oldRequired = replacedColumn.rqd;
            const isUUIDColumn = replacedColumn.uidt === _nocodbsdk.UITypes.UUID;
            replacedColumn.title = title;
            replacedColumn.column_name = title.toLowerCase().replace(/ /g, '_');
            // remove default value to avoid filling existing empty rows
            // Exception: UUID columns need their cdf (gen_random_uuid()) to function
            if (!isUUIDColumn) {
                replacedColumn.cdf = null;
            }
            // remove required to avoid filling existing empty rows
            if (oldRequired) {
                replacedColumn.rqd = false;
            }
            Object.assign(replacedColumn, extra);
            const idMap = await this.importService.importModels(context, {
                baseId,
                sourceId: source.id,
                data: [
                    exportedModel
                ],
                user,
                req,
                externalModels: relatedModels,
                existingModel: sourceModel,
                importColumnIds: [
                    columnId
                ],
                columnWebhookManager
            });
            (0, _helpers.elapsedTime)(hrTime, 'import model schema', 'duplicateColumn');
            if (!idMap) {
                throw new Error(`Import failed for model '${sourceModel.id}'`);
            }
            if (!excludeData && // ignore data if replaced column is derivative types or auto-generated types like UUID
            ![
                _nocodbsdk.UITypes.Button,
                _nocodbsdk.UITypes.Formula,
                _nocodbsdk.UITypes.Barcode,
                _nocodbsdk.UITypes.QrCode,
                _nocodbsdk.UITypes.Rollup,
                _nocodbsdk.UITypes.Lookup,
                _nocodbsdk.UITypes.UUID
            ].includes(replacedColumn.uidt)) {
                const fields = {};
                fields[sourceModel.id] = [
                    sourceModel.primaryKey.id
                ];
                fields[sourceModel.id].push(columnId);
                for (const md of relatedModels){
                    const bts = md.columns.filter((c)=>{
                        var _c_meta;
                        return (0, _nocodbsdk.isLinksOrLTAR)(c) && (c.colOptions.type === _nocodbsdk.RelationTypes.BELONGS_TO || c.colOptions.type === _nocodbsdk.RelationTypes.ONE_TO_ONE && ((_c_meta = c.meta) == null ? void 0 : _c_meta.bt)) && c.colOptions.fk_related_model_id === sourceModel.id;
                    }).map((c)=>c.id);
                    if (bts.length > 0) {
                        fields[md.id] = fields[md.id] ? fields[md.id] : [
                            md.primaryKey.id
                        ];
                        fields[md.id].push(...bts);
                    }
                }
                await this.importModelsData(context, context, {
                    idMap,
                    sourceProject: base,
                    sourceModels: [],
                    destProject: base,
                    destBase: source,
                    hrTime,
                    modelFieldIds: fields,
                    externalModels: [
                        sourceModel,
                        ...relatedModels.filter((m)=>m.id !== sourceModel.id)
                    ],
                    req
                });
                (0, _helpers.elapsedTime)(hrTime, 'import model data', 'duplicateColumn');
            }
            const destColumn = await _models.Column.get(context, {
                source_id: base.id,
                colId: (0, _exportImportHelpers.findWithIdentifier)(idMap, sourceColumn.id)
            });
            // update cdf and rqd
            // Skip for UUID columns since their cdf was preserved during import
            if (!(0, _nocodbsdk.isVirtualCol)(destColumn) && !(0, _nocodbsdk.isAIPromptCol)(destColumn) && destColumn.uidt !== _nocodbsdk.UITypes.UUID) {
                await this.columnsService.columnUpdate(context, {
                    columnId: (0, _exportImportHelpers.findWithIdentifier)(idMap, sourceColumn.id),
                    column: _extends({}, destColumn, {
                        cdf: oldCdf
                    }, oldRequired ? {
                        rqd: oldRequired
                    } : {}),
                    user: req.user,
                    req,
                    columnWebhookManager
                });
            }
            this.debugLog(`job completed for ${job.id} (${_Jobs.JobTypes.DuplicateColumn})`);
            const res = {
                id: (0, _exportImportHelpers.findWithIdentifier)(idMap, sourceColumn.id)
            };
            this.appHooksService.emit(_nocodbsdk.AppEvents.COLUMN_DUPLICATE_COMPLETE, {
                table: sourceModel,
                sourceColumn,
                destColumn: await _models.Column.get(context, {
                    colId: res.id
                }),
                user: req.user,
                req,
                context
            });
            await columnWebhookManager.emit();
            return res;
        } catch (e) {
            this.appHooksService.emit(_nocodbsdk.AppEvents.COLUMN_DUPLICATE_FAIL, {
                table: sourceModel,
                sourceColumn,
                user: req.user,
                req,
                context,
                error: e.message
            });
            throw e;
        }
    }
    async importModelsDataWithSameId(targetContext, sourceContext, param) {
        const { sourceProject, sourceModels, destProject, destBase, hrTime, options, req } = param;
        let handledLinks = [];
        let error = null;
        // For same-ID duplication, we need to handle the :: notation properly
        // CSV headers use format: ${base_id}::${source_id}::${model_id}::${column_id}
        // We need to map these hierarchical IDs to the target column IDs (which are the same)
        const identityIdMap = new Map();
        // Get the source from the source project to build correct hierarchical IDs
        const sourceBase = await sourceProject.getSources();
        const sourceSource = sourceBase == null ? void 0 : sourceBase[0];
        if (!sourceSource) {
            throw new Error('Source not found in source project');
        }
        // Build identity map for all models and columns with hierarchical notation
        for (const sourceModel of sourceModels){
            await sourceModel.getColumns(sourceContext);
            // Map model ID with hierarchical notation
            const sourceModelHierarchicalId = `${sourceProject.id}::${sourceSource.id}::${sourceModel.id}`;
            identityIdMap.set(sourceModelHierarchicalId, sourceModel.id);
            identityIdMap.set(sourceModel.id, sourceModel.id);
            for (const col of sourceModel.columns){
                // Map column ID with hierarchical notation from source to target
                const sourceColHierarchicalId = `${sourceProject.id}::${sourceSource.id}::${sourceModel.id}::${col.id}`;
                identityIdMap.set(sourceColHierarchicalId, col.id);
                identityIdMap.set(col.id, col.id);
            }
        }
        // Import data for each source model
        for (const sourceModel of sourceModels){
            if (error) break;
            const dataStream = new _stream.Readable({
                read () {}
            });
            const linkStream = new _stream.Readable({
                read () {}
            });
            this.exportService.streamModelDataAsCsv(sourceContext, {
                dataStream,
                linkStream,
                baseId: sourceProject.id,
                modelId: sourceModel.id,
                handledMmList: handledLinks,
                excludeUsers: options == null ? void 0 : options.excludeUsers
            }).catch((e)=>{
                this.debugLog(e);
                dataStream.push(null);
                linkStream.push(null);
                error = e;
            });
            // For same-ID duplication, the target model has the same ID as source model
            const model = await _models.Model.get(targetContext, sourceModel.id);
            await this.importService.importDataFromCsvStream(targetContext, {
                idMap: identityIdMap,
                dataStream,
                destProject,
                destBase,
                destModel: model,
                req
            });
            handledLinks = await this.importService.importLinkFromCsvStream(targetContext, {
                idMap: identityIdMap,
                linkStream,
                destProject,
                destBase,
                handledLinks
            });
            (0, _helpers.elapsedTime)(hrTime, `import data and links for ${model.title}`, 'importModelsDataWithSameId');
        }
        if (error) throw error;
    }
    async importModelsData(targetContext, sourceContext, param) {
        const { idMap, sourceProject, sourceModels, destProject, destBase, hrTime, modelFieldIds, externalModels, options, req } = param;
        // TODO: [duplicate column optimization] - maybe can only get data related with duplicated column id
        let handledLinks = [];
        let error = null;
        for (const sourceModel of sourceModels){
            if (error) break;
            const dataStream = new _stream.Readable({
                read () {}
            });
            const linkStream = new _stream.Readable({
                read () {}
            });
            this.exportService.streamModelDataAsCsv(sourceContext, {
                dataStream,
                linkStream,
                baseId: sourceProject.id,
                modelId: sourceModel.id,
                handledMmList: handledLinks,
                excludeUsers: options == null ? void 0 : options.excludeUsers
            }).catch((e)=>{
                this.debugLog(e);
                dataStream.push(null);
                linkStream.push(null);
                error = e;
            });
            const model = await _models.Model.get(targetContext, (0, _exportImportHelpers.findWithIdentifier)(idMap, sourceModel.id));
            await this.importService.importDataFromCsvStream(targetContext, {
                idMap,
                dataStream,
                destProject,
                destBase,
                destModel: model,
                req
            });
            handledLinks = await this.importService.importLinkFromCsvStream(targetContext, {
                idMap,
                linkStream,
                destProject,
                destBase,
                handledLinks
            });
            (0, _helpers.elapsedTime)(hrTime, `import data and links for ${model.title}`, 'importModelsData');
        }
        if (error) throw error;
        // update external models (has bt to this model)
        if (externalModels) {
            for (const sourceModel of externalModels){
                const fields = modelFieldIds == null ? void 0 : modelFieldIds[sourceModel.id];
                if (!fields) continue;
                const dataStream = new _stream.Readable({
                    read () {}
                });
                const linkStream = new _stream.Readable({
                    read () {}
                });
                let error = null;
                this.exportService.streamModelDataAsCsv(targetContext, {
                    dataStream,
                    linkStream,
                    baseId: sourceProject.id,
                    modelId: sourceModel.id,
                    handledMmList: handledLinks,
                    _fieldIds: fields
                }).catch((e)=>{
                    this.debugLog(e);
                    dataStream.push(null);
                    linkStream.push(null);
                    error = e;
                });
                const headers = [];
                let chunk = [];
                const model = await _models.Model.get(targetContext, sourceModel.id);
                await new Promise((resolve)=>{
                    _papaparse.default.parse(dataStream, {
                        newline: '\r\n',
                        step: async (results, parser)=>{
                            if (!headers.length) {
                                parser.pause();
                                for (const header of results.data){
                                    const id = idMap.get(header);
                                    if (id) {
                                        const col = await _models.Column.get(targetContext, {
                                            source_id: destBase.id,
                                            colId: id
                                        });
                                        if (col) {
                                            var _col_colOptions, _col_colOptions1, _col_meta;
                                            if (((_col_colOptions = col.colOptions) == null ? void 0 : _col_colOptions.type) === _nocodbsdk.RelationTypes.BELONGS_TO || ((_col_colOptions1 = col.colOptions) == null ? void 0 : _col_colOptions1.type) === _nocodbsdk.RelationTypes.ONE_TO_ONE && ((_col_meta = col.meta) == null ? void 0 : _col_meta.bt)) {
                                                const childCol = await _models.Column.get(targetContext, {
                                                    source_id: destBase.id,
                                                    colId: col.colOptions.fk_child_column_id
                                                });
                                                if (childCol) {
                                                    headers.push(childCol.column_name);
                                                } else {
                                                    headers.push(null);
                                                    this.debugLog(`child column not found (${id})`);
                                                }
                                            } else {
                                                headers.push(col.column_name);
                                            }
                                        } else {
                                            headers.push(null);
                                            this.debugLog(`column not found (${id})`);
                                        }
                                    } else {
                                        headers.push(null);
                                        this.debugLog(`id not found (${header})`);
                                    }
                                }
                                parser.resume();
                            } else {
                                if (results.errors.length === 0) {
                                    const row = {};
                                    for(let i = 0; i < headers.length; i++){
                                        if (headers[i]) {
                                            if (results.data[i] !== '') {
                                                if (results.data[i] === '__nc_empty_string__') {
                                                    row[headers[i]] = '';
                                                } else {
                                                    row[headers[i]] = results.data[i];
                                                }
                                            }
                                        }
                                    }
                                    chunk.push(row);
                                    if (chunk.length > 1000) {
                                        parser.pause();
                                        try {
                                            // remove empty rows (only pk is present)
                                            chunk = chunk.filter((r)=>Object.keys(r).length > 1);
                                            if (chunk.length > 0) {
                                                await this.bulkDataService.bulkDataUpdate(targetContext, {
                                                    baseName: destProject.id,
                                                    tableName: model.id,
                                                    body: chunk,
                                                    cookie: req,
                                                    raw: true
                                                });
                                            }
                                        } catch (e) {
                                            this.debugLog(e);
                                        }
                                        chunk = [];
                                        parser.resume();
                                    }
                                }
                            }
                        },
                        complete: async ()=>{
                            if (chunk.length > 0) {
                                try {
                                    // remove empty rows (only pk is present)
                                    chunk = chunk.filter((r)=>Object.keys(r).length > 1);
                                    if (chunk.length > 0) {
                                        await this.bulkDataService.bulkDataUpdate(targetContext, {
                                            baseName: destProject.id,
                                            tableName: model.id,
                                            body: chunk,
                                            cookie: req,
                                            raw: true
                                        });
                                    }
                                } catch (e) {
                                    this.debugLog(e);
                                }
                                chunk = [];
                            }
                            resolve(null);
                        }
                    });
                });
                if (error) throw error;
                handledLinks = await this.importService.importLinkFromCsvStream(targetContext, {
                    idMap,
                    linkStream,
                    destProject,
                    destBase,
                    handledLinks
                });
                (0, _helpers.elapsedTime)(hrTime, `map existing links to ${model.title}`, 'importModelsData');
            }
        }
    }
    constructor(exportService, importService, projectsService, bulkDataService, columnsService, appHooksService, tablesService, telemetryService){
        this.exportService = exportService;
        this.importService = importService;
        this.projectsService = projectsService;
        this.bulkDataService = bulkDataService;
        this.columnsService = columnsService;
        this.appHooksService = appHooksService;
        this.tablesService = tablesService;
        this.telemetryService = telemetryService;
        this.debugLog = (0, _debug.default)('nc:jobs:duplicate');
    }
};
DuplicateProcessor = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _exportservice.ExportService === "undefined" ? Object : _exportservice.ExportService,
        typeof _importservice.ImportService === "undefined" ? Object : _importservice.ImportService,
        typeof _basesservice.BasesService === "undefined" ? Object : _basesservice.BasesService,
        typeof _bulkdataaliasservice.BulkDataAliasService === "undefined" ? Object : _bulkdataaliasservice.BulkDataAliasService,
        typeof _columnsservice.ColumnsService === "undefined" ? Object : _columnsservice.ColumnsService,
        typeof _apphooksservice.AppHooksService === "undefined" ? Object : _apphooksservice.AppHooksService,
        typeof _tablesservice.TablesService === "undefined" ? Object : _tablesservice.TablesService,
        typeof _telemetryservice.TelemetryService === "undefined" ? Object : _telemetryservice.TelemetryService
    ])
], DuplicateProcessor);
